/** Survives React Router navigations that drop location.state (e.g. ProtectedRoute redirect). */
const STORAGE_KEY = 'bhg-pending-logout-reason';

export type LogoutReason = 'session_expired' | 'session_revoked';

function isLogoutReason(value: string): value is LogoutReason {
  return value === 'session_expired' || value === 'session_revoked';
}

export function setPendingLogoutReason(reason: LogoutReason): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, reason);
  } catch {
    // Private mode / quota — location.state may still work
  }
}

/** Read without removing — use when building a redirect that may be overwritten. */
export function peekPendingLogoutReason(): LogoutReason | undefined {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value && isLogoutReason(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

/** Read once for display on the login page. */
export function consumePendingLogoutReason(): LogoutReason | undefined {
  const value = peekPendingLogoutReason();
  if (!value) return undefined;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return value;
}
